import usePreviousRef from './usePreviousRef';

export default function usePrevious<T>(value: T): T {
  return usePreviousRef(value).current;
}
